var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _rect854, _rect855, _rect856, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _rect876, _rect877, _rect878, _rect879, _rect880, _rect881, _rect882, _rect883, _rect884, _rect885, _rect886, _rect887, _rect888, _rect889, _rect890, _rect891, _rect892, _rect893, _rect894, _rect895, _rect896, _rect897, _rect898, _rect899, _rect900, _rect901, _rect902, _rect903, _rect904, _rect905, _rect906, _rect907, _rect908, _rect909, _rect910, _rect911, _rect912, _rect913, _rect914, _rect915, _rect916, _rect917, _rect918, _rect919, _rect920, _rect921, _rect922, _rect923, _rect924, _rect925, _rect926, _rect927, _rect928, _rect929, _rect930, _rect931, _rect932, _rect933, _rect934, _rect935, _rect936, _rect937, _rect938, _rect939, _rect940, _rect941, _rect942, _rect943, _rect944, _rect945, _rect946, _rect947, _rect948, _rect949, _rect950, _rect951, _rect952, _rect953, _rect954, _rect955, _rect956, _rect957, _rect958, _rect959, _rect960, _rect961, _rect962, _rect963, _rect964, _rect965, _rect966, _rect967, _rect968, _rect969, _rect970, _rect971, _rect972, _rect973, _rect974, _rect975, _rect976, _rect977, _rect978, _rect979, _rect980, _rect981, _rect982, _rect983, _rect984, _rect985, _rect986, _rect987, _rect988, _rect989, _rect990, _rect991, _rect992, _rect993, _rect994, _rect995, _rect996, _rect997, _rect998, _rect999, _rect1000, _rect1001, _rect1002, _rect1003, _rect1004, _rect1005, _rect1006, _rect1007, _rect1008, _rect1009, _rect1010, _rect1011, _rect1012, _rect1013, _rect1014, _rect1015, _rect1016, _rect1017, _rect1018, _rect1019, _rect1020, _rect1021, _rect1022, _rect1023, _rect1024, _rect1025, _rect1026, _rect1027, _rect1028, _rect1029, _rect1030, _rect1031, _rect1032, _rect1033, _rect1034, _rect1035, _rect1036, _rect1037, _rect1038, _rect1039, _rect1040, _rect1041, _rect1042, _rect1043, _rect1044, _rect1045, _rect1046, _rect1047, _rect1048, _rect1049, _rect1050, _rect1051, _rect1052, _rect1053, _rect1054, _rect1055, _rect1056, _rect1057, _rect1058, _rect1059, _rect1060, _rect1061, _rect1062, _rect1063, _rect1064, _rect1065, _rect1066, _rect1067, _rect1068, _rect1069, _rect1070, _rect1071, _rect1072, _rect1073, _rect1074, _rect1075, _rect1076, _rect1077, _rect1078, _rect1079, _rect1080, _rect1081, _rect1082, _rect1083, _rect1084, _rect1085, _rect1086, _rect1087, _rect1088, _rect1089, _rect1090, _rect1091, _rect1092, _rect1093, _rect1094, _rect1095, _rect1096, _rect1097;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniMe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7066,
    height: 7066,
    viewBox: "0 0 7066 7066",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000001"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#181818"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020402"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#303030"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#66300C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#371904"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0C0600"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 164.311,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#090A0A"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#333234"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#250E02"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#512608"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#68320D"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#52280A"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3B1903"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E340C"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360D"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350E"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C360E"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#65320B"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4E2306"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#441F05"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#371801"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2A1401"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0C0400"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 328.622,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4A4D4B"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#180B00"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F3710"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C360E"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E340C"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350F"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D380D"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F350B"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360E"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360E"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360F"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C350E"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360E"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D340E"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C360E"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C340E"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350F"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F3812"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D370E"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#492106"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 492.933,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1643.11,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 1807.42,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#20201E"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#262525"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#492307"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F340D"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#70380D"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360C"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360C"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350E"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360C"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360D"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C370D"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D340D"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360E"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F350E"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350E"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D370D"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C340D"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E340F"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350F"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360C"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1B0A01"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 657.244,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 1150.18,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 1314.49,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 1478.8,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 1643.11,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 1807.42,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#301802"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#64310B"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360C"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360D"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E370D"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D340C"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360C"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#70350D"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F350C"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360B"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360E"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360C"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360D"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360D"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F350D"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F330D"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F350C"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E340E"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D340D"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#180A00"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 821.556,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#211002"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 1150.18,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#232421"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 1314.49,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2D1503"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 1478.8,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B360E"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 1643.11,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 1807.42,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F350E"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E370D"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E370E"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360C"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F370D"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360C"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350E"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350E"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E370C"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360C"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360E"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#70360E"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360D"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360F"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360D"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350E"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#70370D"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C350C"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360D"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360E"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D370C"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350C"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C360F"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 985.867,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#75380E"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 1314.49,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 1478.8,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#401F09"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 1643.11,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D370E"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 1807.42,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360E"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360C"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350C"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#70340C"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E370D"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E370D"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C370B"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360E"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350E"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350C"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E340E"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F350F"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360E"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360E"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360C"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350C"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360D"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360C"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360D"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E340E"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#401D07"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#69340B"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 1150.18,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#150802"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 1478.8,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 1643.11,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#391C09"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 1807.42,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E3A15"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360E"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E370E"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360D"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C360D"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F350E"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E370C"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360E"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360E"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D340E"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E380F"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360E"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360D"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F350E"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F360E"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E370E"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360F"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360E"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350E"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C350E"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6A340D"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 1314.49,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 1643.11,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 1807.42,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#593018"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6F3710"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B350C"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C350D"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4B2406"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C370D"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350E"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#452007"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020000"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E360D"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C330E"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350C"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D340A"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D340C"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D360D"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B340E"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0D0300"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010100"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 1478.8,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#381A05"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2E1503"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000200"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#030000"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B78862"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B350D"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C350C"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B340E"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C360F"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C350D"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D370E"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C340D"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E340E"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C360D"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6E350D"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B340C"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#69350D"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#130700"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 1643.11,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010100"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#050504"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000001"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#EABB92"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C69E"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020000"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010000"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#572907"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D370C"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C350D"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B350D"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C340C"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D330B"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6A340C"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C340D"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D350D"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6D340B"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B340E"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6A340D"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#68330B"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#321604"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 1807.42,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 1807.42,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1D1F1C"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010000"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F9F7F6"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FFDBB0"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F7C59E"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C89E"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C59C"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010000"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6A340E"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6A350D"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1A0B00"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B350C"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6A330D"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B340D"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C320C"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C340B"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C320C"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C330D"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#69340E"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#381B05"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#62300D"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#592C0C"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2D1605"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 6736.76,
    y: 1971.73,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1A1A18"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F8F6F4"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C39F"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C59C"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2D1503"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#060200"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0B0400"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#66310D"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#69330D"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#472006"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#642F0C"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#401D04"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#68330C"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#451F06"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#441D08"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#401C06"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#54270A"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0A0300"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 6736.76,
    y: 2136.04,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FBFEFD"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000001"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FBFEFD"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#040505"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F9F6F1"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F7C49C"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F7C49C"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#563D2D"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F9CAA0"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#090500"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#442008"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1B0C01"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3D1D07"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E1C04"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3F1F07"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E1D06"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E1D06"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#441F08"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3F1D06"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3D1C05"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3B1B07"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#361904"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 2300.36,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FBFEFD"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1B1B18"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F7F6F3"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F4C59F"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C39C"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C39C"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#120905"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#060200"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#71523D"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#050100"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3D1B04"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E1C05"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3D1904"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E1C06"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3D1C05"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3D1B04"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3C1B04"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 2464.67,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010000"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010100"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 328.623,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#040301"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 492.934,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#C4BCAD"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 657.244,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#110D08"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FBFEFD"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F8F6F4"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FBF8F7"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C39A"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C49C"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F7C69A"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#A57E5C"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F4C49B"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B4845E"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C29A"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020001"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3F1C06"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E1B06"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3C1D05"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E1D06"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E1D06"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3B1A06"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#361706"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 2628.98,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E3B3C"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 164.312,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#623C1A"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 328.623,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010100"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 492.934,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FEF5E5"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 657.244,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FEF5E7"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 821.557,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020203"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1E1D1A"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FAFAF7"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F8C89E"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F4C49D"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C49B"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C39A"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#120C08"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FDDAAD"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#AB7C57"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F4C397"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F2C198"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#180B00"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3C1B05"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3A1A06"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3B1B06"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3A1A04"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#170A02"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 2793.29,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#373837"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 164.312,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#EEE3D4"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 328.623,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#C1BAAD"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 492.934,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FFF6E8"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 657.244,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FFF5E6"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 821.557,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FFF6E6"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 985.867,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#040203"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#272728"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FCD1A5"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C59B"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C39B"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C69E"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C59C"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020000"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C39B"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C59B"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F3C29B"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F4C49B"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#180B02"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#250F00"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#211003"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3C1C06"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C0C01"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 2957.6,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 164.312,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#ABA092"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 328.623,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#9E968C"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 492.934,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#999388"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 657.244,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FEF5E7"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 821.557,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#FEFAEE"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 985.867,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0A0804"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#313131"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#454747"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#464846"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#464548"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#454948"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4C4C4C"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#060502"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F6C49D"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C59D"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C69D"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2B2015"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C0D02"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1F0E01"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1B0C01"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#190C00"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010000"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 3121.91,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#030201"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 328.623,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#050302"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 492.934,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#A1998B"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 657.244,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#9D978C"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 821.557,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#A9A093"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 985.867,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#452913"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 1150.18,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#040300"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#191C19"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2E2D2C"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4A4C4C"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#454645"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#464745"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#434544"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#454647"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#454545"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#444745"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#454547"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#464545"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#444545"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#464947"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010000"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 3286.22,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 657.244,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#060300"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 1150.18,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#050000"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 1314.49,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#764C27"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 1478.8,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#653F1F"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#292728"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#353636"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#464748"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#454646"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#444645"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#434543"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#444344"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#292B2B"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#272828"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4C4E4F"
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 3450.53,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#09090B"
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 1478.8,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#050300"
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 1643.11,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#8B5E30"
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#292929"
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#252726"
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#262727"
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1E2122"
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C1D1D"
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000101"
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#AFD6A8"
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B3DBAC"
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 3614.84,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3F4040"
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 1643.11,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#030200"
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 1807.42,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#38200F"
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0A0500"
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#070606"
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#060606"
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010000"
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010602"
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#040A05"
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#82AD86"
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#81AB83"
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 3779.16,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3F3D3D"
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020000"
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#7A502B"
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#120B05"
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#C19972"
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#090301"
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#030502"
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000401"
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010300"
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#85B288"
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#7BA881"
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 3943.47,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#323335"
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3C2C20"
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C69C"
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#161008"
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C69D"
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#030301"
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010400"
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010803"
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020400"
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#699E7B"
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#7CAA82"
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#77A580"
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#72A07A"
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6C9A78"
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 4107.78,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#503C28"
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#CA946E"
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#F5C89D"
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E6C52"
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010100"
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 4272.09,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#282728"
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#060300"
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#C4946E"
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#183023"
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#60886D"
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B1D7AB"
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#638E70"
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#89B48A"
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#383837"
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 4436.4,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#21211E"
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#514336"
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#86AE88"
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#79A37F"
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B2DBAD"
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B2D7AA"
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5C8869"
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1D2D1F"
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#598566"
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#89B48A"
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 4600.71,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0D0B0C"
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#548466"
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5A8A6A"
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#60916E"
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#040A07"
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#416C57"
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 4765.02,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1F1E1F"
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#080908"
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#080E08"
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#14241D"
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#538367"
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#548063"
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#528064"
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 4929.33,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#171715"
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#161615"
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#121414"
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020502"
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#263F2E"
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#48765C"
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34DB82"
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#26BB6B"
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 5093.64,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C1E1D"
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C1D1A"
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1E1E1C"
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C1C1D"
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1E1E1E"
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C1F1C"
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1A1917"
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#46735B"
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#598B6C"
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E6B53"
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#48775E"
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#47765B"
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#47755A"
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#254331"
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#08130C"
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 5257.96,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#191A1A"
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#131313"
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#232323"
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1F1D1F"
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1D1D1D"
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C1B19"
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#191B1B"
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1B1D1B"
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C1D1C"
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C1E1E"
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1F1E1D"
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#191817"
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020603"
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020501"
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#72A27D"
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#71A07C"
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#669574"
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#251707"
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4A2F15"
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 5422.27,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#242426"
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#222021"
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#221F22"
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#070706"
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#151413"
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0E0F10"
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0D0C0D"
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#121411"
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#131214"
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#121214"
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#131412"
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#121412"
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0B090B"
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#030402"
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#060400"
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#211207"
  })), _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#593618"
  })), _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#60391D"
  })), _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#180C03"
  })), _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#9B6B3E"
  })), _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#82582E"
  })), _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#734C26"
  })), _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 5586.58,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#252426"
  })), _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#252424"
  })), _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#070706"
  })), _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#090401"
  })), _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010202"
  })), _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect887 || (_rect887 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect888 || (_rect888 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect889 || (_rect889 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect890 || (_rect890 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020100"
  })), _rect891 || (_rect891 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6A4626"
  })), _rect892 || (_rect892 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#77502F"
  })), _rect893 || (_rect893 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#775231"
  })), _rect894 || (_rect894 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#7E5733"
  })), _rect895 || (_rect895 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#251607"
  })), _rect896 || (_rect896 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BD8D5B"
  })), _rect897 || (_rect897 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#895D35"
  })), _rect898 || (_rect898 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#825A32"
  })), _rect899 || (_rect899 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#C2915F"
  })), _rect900 || (_rect900 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#A37144"
  })), _rect901 || (_rect901 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 5750.89,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0C0B09"
  })), _rect902 || (_rect902 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect903 || (_rect903 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#181818"
  })), _rect904 || (_rect904 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#191817"
  })), _rect905 || (_rect905 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#111110"
  })), _rect906 || (_rect906 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect907 || (_rect907 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#252525"
  })), _rect908 || (_rect908 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect909 || (_rect909 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#29160A"
  })), _rect910 || (_rect910 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#291709"
  })), _rect911 || (_rect911 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2B1A0B"
  })), _rect912 || (_rect912 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#281508"
  })), _rect913 || (_rect913 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3A2110"
  })), _rect914 || (_rect914 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1B0D04"
  })), _rect915 || (_rect915 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#160C02"
  })), _rect916 || (_rect916 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#392210"
  })), _rect917 || (_rect917 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#34200D"
  })), _rect918 || (_rect918 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#37210D"
  })), _rect919 || (_rect919 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3C2411"
  })), _rect920 || (_rect920 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3F2712"
  })), _rect921 || (_rect921 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E2813"
  })), _rect922 || (_rect922 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#724D2C"
  })), _rect923 || (_rect923 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2B1907"
  })), _rect924 || (_rect924 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1D0E05"
  })), _rect925 || (_rect925 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B88A5A"
  })), _rect926 || (_rect926 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BE8C5A"
  })), _rect927 || (_rect927 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BE8F5F"
  })), _rect928 || (_rect928 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BE8F60"
  })), _rect929 || (_rect929 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B58555"
  })), _rect930 || (_rect930 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 5915.2,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect931 || (_rect931 = /*#__PURE__*/React.createElement("rect", {
    x: 1971.73,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#373837"
  })), _rect932 || (_rect932 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect933 || (_rect933 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#181715"
  })), _rect934 || (_rect934 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#181819"
  })), _rect935 || (_rect935 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#151614"
  })), _rect936 || (_rect936 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#141513"
  })), _rect937 || (_rect937 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#150A03"
  })), _rect938 || (_rect938 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3B220E"
  })), _rect939 || (_rect939 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5D3D20"
  })), _rect940 || (_rect940 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#59381D"
  })), _rect941 || (_rect941 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5A391E"
  })), _rect942 || (_rect942 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5E3B1F"
  })), _rect943 || (_rect943 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#603E20"
  })), _rect944 || (_rect944 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#613D22"
  })), _rect945 || (_rect945 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5F3F20"
  })), _rect946 || (_rect946 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5E3B21"
  })), _rect947 || (_rect947 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#492D14"
  })), _rect948 || (_rect948 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4D3117"
  })), _rect949 || (_rect949 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#7B5633"
  })), _rect950 || (_rect950 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#785231"
  })), _rect951 || (_rect951 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#765131"
  })), _rect952 || (_rect952 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#795431"
  })), _rect953 || (_rect953 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1C0D05"
  })), _rect954 || (_rect954 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#A77B4C"
  })), _rect955 || (_rect955 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B98859"
  })), _rect956 || (_rect956 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B38052"
  })), _rect957 || (_rect957 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BE8F61"
  })), _rect958 || (_rect958 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#744E2A"
  })), _rect959 || (_rect959 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 6079.51,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B2814F"
  })), _rect960 || (_rect960 = /*#__PURE__*/React.createElement("rect", {
    x: 2136.04,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0B0A09"
  })), _rect961 || (_rect961 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect962 || (_rect962 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect963 || (_rect963 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#171717"
  })), _rect964 || (_rect964 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect965 || (_rect965 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#462B15"
  })), _rect966 || (_rect966 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#53341B"
  })), _rect967 || (_rect967 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#644122"
  })), _rect968 || (_rect968 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4F301A"
  })), _rect969 || (_rect969 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#644125"
  })), _rect970 || (_rect970 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#6B4627"
  })), _rect971 || (_rect971 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#644224"
  })), _rect972 || (_rect972 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#513316"
  })), _rect973 || (_rect973 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#57361A"
  })), _rect974 || (_rect974 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5C3B1F"
  })), _rect975 || (_rect975 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#613D20"
  })), _rect976 || (_rect976 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5D3E20"
  })), _rect977 || (_rect977 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#7C5533"
  })), _rect978 || (_rect978 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#38210E"
  })), _rect979 || (_rect979 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#331B0D"
  })), _rect980 || (_rect980 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2B1A08"
  })), _rect981 || (_rect981 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#231104"
  })), _rect982 || (_rect982 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#AF7F53"
  })), _rect983 || (_rect983 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BD8C5C"
  })), _rect984 || (_rect984 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BD915F"
  })), _rect985 || (_rect985 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BC8D5E"
  })), _rect986 || (_rect986 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#8C6136"
  })), _rect987 || (_rect987 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 6243.82,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#94673E"
  })), _rect988 || (_rect988 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect989 || (_rect989 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1A0D02"
  })), _rect990 || (_rect990 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#402610"
  })), _rect991 || (_rect991 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3D2411"
  })), _rect992 || (_rect992 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#422613"
  })), _rect993 || (_rect993 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#412511"
  })), _rect994 || (_rect994 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#57381C"
  })), _rect995 || (_rect995 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3B220E"
  })), _rect996 || (_rect996 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#503317"
  })), _rect997 || (_rect997 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#58361D"
  })), _rect998 || (_rect998 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#54361B"
  })), _rect999 || (_rect999 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#563319"
  })), _rect1000 || (_rect1000 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4C3017"
  })), _rect1001 || (_rect1001 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#513118"
  })), _rect1002 || (_rect1002 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2B1908"
  })), _rect1003 || (_rect1003 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2B1809"
  })), _rect1004 || (_rect1004 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5C3C20"
  })), _rect1005 || (_rect1005 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5E3B21"
  })), _rect1006 || (_rect1006 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#623D20"
  })), _rect1007 || (_rect1007 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#664121"
  })), _rect1008 || (_rect1008 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1F1209"
  })), _rect1009 || (_rect1009 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#734C2A"
  })), _rect1010 || (_rect1010 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BE905E"
  })), _rect1011 || (_rect1011 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#AC7E4E"
  })), _rect1012 || (_rect1012 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#8E643A"
  })), _rect1013 || (_rect1013 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#885D37"
  })), _rect1014 || (_rect1014 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1015 || (_rect1015 = /*#__PURE__*/React.createElement("rect", {
    x: 6736.76,
    y: 6408.13,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1016 || (_rect1016 = /*#__PURE__*/React.createElement("rect", {
    x: 2300.36,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#373434"
  })), _rect1017 || (_rect1017 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3C2511"
  })), _rect1018 || (_rect1018 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3D2512"
  })), _rect1019 || (_rect1019 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#402713"
  })), _rect1020 || (_rect1020 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#341C0D"
  })), _rect1021 || (_rect1021 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#432914"
  })), _rect1022 || (_rect1022 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5C3C20"
  })), _rect1023 || (_rect1023 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#382111"
  })), _rect1024 || (_rect1024 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#36200E"
  })), _rect1025 || (_rect1025 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#38220E"
  })), _rect1026 || (_rect1026 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#39200F"
  })), _rect1027 || (_rect1027 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3A240E"
  })), _rect1028 || (_rect1028 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3C2310"
  })), _rect1029 || (_rect1029 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#321C0B"
  })), _rect1030 || (_rect1030 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#311A0B"
  })), _rect1031 || (_rect1031 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#4F3017"
  })), _rect1032 || (_rect1032 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5F3E21"
  })), _rect1033 || (_rect1033 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#492F17"
  })), _rect1034 || (_rect1034 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#5E3C21"
  })), _rect1035 || (_rect1035 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#623F21"
  })), _rect1036 || (_rect1036 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2F1B09"
  })), _rect1037 || (_rect1037 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#8E6239"
  })), _rect1038 || (_rect1038 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#664122"
  })), _rect1039 || (_rect1039 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#90653B"
  })), _rect1040 || (_rect1040 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#BE8F5E"
  })), _rect1041 || (_rect1041 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#644121"
  })), _rect1042 || (_rect1042 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0C0503"
  })), _rect1043 || (_rect1043 = /*#__PURE__*/React.createElement("rect", {
    x: 6736.76,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#503117"
  })), _rect1044 || (_rect1044 = /*#__PURE__*/React.createElement("rect", {
    x: 6901.07,
    y: 6572.44,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000100"
  })), _rect1045 || (_rect1045 = /*#__PURE__*/React.createElement("rect", {
    x: 2464.67,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#000101"
  })), _rect1046 || (_rect1046 = /*#__PURE__*/React.createElement("rect", {
    x: 2628.98,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#170D05"
  })), _rect1047 || (_rect1047 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#231407"
  })), _rect1048 || (_rect1048 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#382210"
  })), _rect1049 || (_rect1049 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3B2211"
  })), _rect1050 || (_rect1050 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E2512"
  })), _rect1051 || (_rect1051 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#422713"
  })), _rect1052 || (_rect1052 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#201306"
  })), _rect1053 || (_rect1053 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#25150A"
  })), _rect1054 || (_rect1054 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#351D0B"
  })), _rect1055 || (_rect1055 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#251309"
  })), _rect1056 || (_rect1056 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#28170A"
  })), _rect1057 || (_rect1057 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3C2210"
  })), _rect1058 || (_rect1058 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#3E2612"
  })), _rect1059 || (_rect1059 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#211207"
  })), _rect1060 || (_rect1060 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#422811"
  })), _rect1061 || (_rect1061 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2A1708"
  })), _rect1062 || (_rect1062 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2E1909"
  })), _rect1063 || (_rect1063 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2D1A0A"
  })), _rect1064 || (_rect1064 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#261506"
  })), _rect1065 || (_rect1065 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#C89667"
  })), _rect1066 || (_rect1066 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#A97A4D"
  })), _rect1067 || (_rect1067 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#AA7A4C"
  })), _rect1068 || (_rect1068 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#AC7C49"
  })), _rect1069 || (_rect1069 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#AC7A49"
  })), _rect1070 || (_rect1070 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#130B02"
  })), _rect1071 || (_rect1071 = /*#__PURE__*/React.createElement("rect", {
    x: 6736.76,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#422711"
  })), _rect1072 || (_rect1072 = /*#__PURE__*/React.createElement("rect", {
    x: 6901.07,
    y: 6736.76,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1073 || (_rect1073 = /*#__PURE__*/React.createElement("rect", {
    x: 2793.29,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#010101"
  })), _rect1074 || (_rect1074 = /*#__PURE__*/React.createElement("rect", {
    x: 2957.6,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#050402"
  })), _rect1075 || (_rect1075 = /*#__PURE__*/React.createElement("rect", {
    x: 3121.91,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0D0C0C"
  })), _rect1076 || (_rect1076 = /*#__PURE__*/React.createElement("rect", {
    x: 3286.22,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#2E2B30"
  })), _rect1077 || (_rect1077 = /*#__PURE__*/React.createElement("rect", {
    x: 3450.53,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#262626"
  })), _rect1078 || (_rect1078 = /*#__PURE__*/React.createElement("rect", {
    x: 3614.85,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#201F20"
  })), _rect1079 || (_rect1079 = /*#__PURE__*/React.createElement("rect", {
    x: 3779.15,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0C0B0A"
  })), _rect1080 || (_rect1080 = /*#__PURE__*/React.createElement("rect", {
    x: 3943.47,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#030302"
  })), _rect1081 || (_rect1081 = /*#__PURE__*/React.createElement("rect", {
    x: 4107.78,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020100"
  })), _rect1082 || (_rect1082 = /*#__PURE__*/React.createElement("rect", {
    x: 4272.09,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#020300"
  })), _rect1083 || (_rect1083 = /*#__PURE__*/React.createElement("rect", {
    x: 4436.4,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1084 || (_rect1084 = /*#__PURE__*/React.createElement("rect", {
    x: 4600.71,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1085 || (_rect1085 = /*#__PURE__*/React.createElement("rect", {
    x: 4765.02,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1086 || (_rect1086 = /*#__PURE__*/React.createElement("rect", {
    x: 4929.33,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1087 || (_rect1087 = /*#__PURE__*/React.createElement("rect", {
    x: 5093.64,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1088 || (_rect1088 = /*#__PURE__*/React.createElement("rect", {
    x: 5257.96,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1089 || (_rect1089 = /*#__PURE__*/React.createElement("rect", {
    x: 5422.27,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#070500"
  })), _rect1090 || (_rect1090 = /*#__PURE__*/React.createElement("rect", {
    x: 5586.58,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0A0400"
  })), _rect1091 || (_rect1091 = /*#__PURE__*/React.createElement("rect", {
    x: 5750.89,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#1A1005"
  })), _rect1092 || (_rect1092 = /*#__PURE__*/React.createElement("rect", {
    x: 5915.2,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#B88958"
  })), _rect1093 || (_rect1093 = /*#__PURE__*/React.createElement("rect", {
    x: 6079.51,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#A87848"
  })), _rect1094 || (_rect1094 = /*#__PURE__*/React.createElement("rect", {
    x: 6243.82,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1095 || (_rect1095 = /*#__PURE__*/React.createElement("rect", {
    x: 6408.13,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "black"
  })), _rect1096 || (_rect1096 = /*#__PURE__*/React.createElement("rect", {
    x: 6572.44,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#0A0A0A"
  })), _rect1097 || (_rect1097 = /*#__PURE__*/React.createElement("rect", {
    x: 6736.76,
    y: 6901.07,
    width: 164.311,
    height: 164.311,
    rx: 82.1556,
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniMe);
export default __webpack_public_path__ + "static/media/MiniMe.4905511344d3033ad6fe292781e0a0b2.svg";
export { ForwardRef as ReactComponent };